import { type SvgIconProps } from '@common/components/svgs/props';

function IconError({ size = 144, ...rest }: Readonly<SvgIconProps>) {
  return (
    <svg
      {...rest}
      height={size}
      width={size}
      viewBox="0 0 144 144"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="svg-Error"
    >
      <path
        d="M66 0.999999C66 0.447714 66.4477 0 67 0H77C77.5523 0 78 0.447715 78 1V134H66V0.999999Z"
        fill="#4D4D4D"
      />
      <path
        d="M45 144C44.4477 144 44 143.552 44 143L44 133C44 132.448 44.4477 132 45 132L99 132C99.5523 132 100 132.448 100 133L100 143C100 143.552 99.5523 144 99 144L45 144Z"
        fill="#4D4D4D"
      />
      <rect x="12" y="16" width="120" height="84" rx="1" fill="#FCB01D" />
      <mask id="path-4-inside-1" fill="white">
        <rect x="20" y="24" width="104" height="67" rx="1" />
      </mask>
      <rect
        x="20"
        y="24"
        width="104"
        height="67"
        rx="1"
        fill="#FCB01D"
        stroke="#4D4D4D"
        strokeWidth="6"
        mask="url(#path-4-inside-1)"
      />
      <path d="M40 59L63.25 41.6795L63.25 76.3205L40 59Z" fill="#4D4D4D" />
      <rect x="63" y="51" width="41" height="16" fill="#4D4D4D" />
    </svg>
  );
}

IconError.displayName = 'Error';

export default IconError;
